<template>
  <div class="TransitionPage">
    <div class="base-wrap">
        <div class="title">
            <span>加入申请</span>
        </div>
        <div v-if="positionLists.total>0" class="hotel-list">
            <div class="hotel-ltitle">酒店名称：{{ positionLists.lists[0].title }}</div>
            <div class="hotel-item">申请时间：{{ positionLists.lists[0].add_time | formatTimestamp(1)}}</div>
        </div>
        <div v-else class="hotel-list">
            <div class="hotel-ltitle">酒店名称：{{ StoreBasicInfo.title }}</div>
            <div class="hotel-item">地址：{{ StoreBasicInfo.province_name}}{{StoreBasicInfo.city_name }}、{{StoreBasicInfo.district_name }}</div>
        </div>
        <span class="text-center mt-1">酒店审核中，请留意您的微信或短信消息</span>
        <!--酒店列表-->
        <el-button type="primary" class="login-btn"  width="100%" @click="logout" >退出登录</el-button>
        <span class="text-center">客服电话:0571-89986918</span>
    </div>
  </div>
</template>

<script>
import { InfiniteScroll } from 'element-ui';
import { data } from 'jquery';
import {mapState,mapActions} from 'vuex'
export default {
  name: 'TransitionPage',
  components: {},
  props: {},
  data() {
    return {
        loading:false,
        infiniteScroll:{},
    };
  },
  computed: {
    ...mapState(['userLoginMessage','positionLists','StoreBasicInfo']),
  },
  watch: {

  },
  created() {
      this.initiali();
  },
  mounted() {
  },
  methods: {
        ...mapActions(['getUserPositionLists','POST_HotelInfo','updateInfo','logout']),
        initiali(){
            //获取已申请关联列表
            this.getUserPositionLists();     
        },
  }
};
</script>

<style lang="scss" scoped>
.login-btn{
    display: block;
    width: 440px;
    margin: 40px auto;
    margin-bottom: 10px;
}
.TransitionPage{
    // background: url(/images/public/bg-login.jpg)  no-repeat;
    background-size: 100%;
    min-width: 1400px;
    height: 100vh;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    background-color: #f3f4f8;
}
.base-wrap{
    width: 1000px;
    background-color: #fff;
    margin-top: 14%;
    border-radius: 10px;
    overflow: hidden;
    box-shadow: 0 1px 6px rgba(0, 0, 0, 0.2);
}
.title{
    font-size: 20px;
    font-weight: bold;
    padding: 14px 0;
    background-color: #f5f7fa;
}
.hotel-list{
    width: 90%;
    margin: 0 auto;
    background-color: #f5f7fa;
    width: 400px;
    border-radius: 6px;
    margin-top: 20px;
    padding: 20px;
}
.hotel-ltitle{
    text-align: left;
    font-weight: bold;
    font-size: 16px;
}
.hotel-item{
    text-align: right;
    border-top: 4px #fff solid;
    margin-top: 10px;
    padding-top: 10px;
    font-size: 12px;
}
.text-center{
    color: #999;
    margin-bottom: 30px;
    display: block;
}
</style>
